import { Component, type ReactNode } from "react";
import { Disclosure, DisclosureButton, DisclosurePanel, Transition } from "@headlessui/react";
import { CaretDownIcon } from "@App/Components/common/Icons";

type FAQItemProps = {
  title: String;
  className: String;
  compact?: boolean;
  background?: string;
  children?: ReactNode;
};

export class FAQItem extends Component<FAQItemProps> {
  public static defaultProps = {
    className: "",
  };

  render(): ReactNode {
    return (
      <div
        className={`${this.props.compact ? "border-t border-neutral-100 p-5 py-3 px-5 md:p-3" : "mt-4"} ${this.props.className}`}
      >
        <Disclosure>
          {({ open }) => (
            <>
              <DisclosureButton
                data-testid="disclosure-button"
                className={`flex justify-between items-center w-full ${this.props.compact ? "" : "py-4 px-5"} text-left rounded focus:outline-none ${this.props.background ? this.props.background : "bg-white"}`}
              >
                <div>{this.props.title}</div>
                <div
                  className={`flex items-center justify-center relative top-[2px] transition-all duration-150 ease-in-out h-full ${
                    open ? "transform rotate-180" : "rotate-0"
                  } w-5 h-5`}
                >
                  <div className="mx-2 flex items-center">
                    <CaretDownIcon />
                  </div>
                </div>
              </DisclosureButton>
              <Transition
                as={"div"}
                show={open}
                enter="transition-opacity duration-400"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-125"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <DisclosurePanel
                  className={`${this.props.compact ? "text-neutral-500 pt-3" : "px-4 pt-4 pb-2"}`}
                >
                  {this.props.children}
                </DisclosurePanel>
              </Transition>
            </>
          )}
        </Disclosure>
      </div>
    );
  }
}
